import { Exchange } from "@urql/core";
import { map, pipe } from "wonka";

export const unwrapRefsExchange: Exchange = ({
  client,
  forward
}) => operations$ => {
  const operationResult$ = pipe(
    operations$,
    map(op => JSON.parse(JSON.stringify(op))),
    forward
  );
  return operationResult$;
};
